import { connect } from "react-redux";
import videocardReducer from "./videocard.reducers";
import videocardActions from "./videocard.actions";

const videoConnect = (VideoCardComponent) => {
    return connect(videocardReducer, { ...videocardActions })(VideoCardComponent);
};

export default videoConnect;